import { ToolManagement } from '@/components/tool-management'

export default function ToolManagementPage() {
  return <ToolManagement />
}
